class LoadMoreButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.spinner = this.querySelector('.load-more__spinner');

    if (!this.dataset.nextUrl) {
      this.hidden = true;
      return;
    }

    this.button.addEventListener('click', () => this.loadMore());
  }

  getTargetGrid() {
    const el = document.getElementById('product-grid');
    if (!el) return null;
    return el.tagName === 'UL' ? el : el.querySelector('ul');
  }

  async loadMore() {
    if (window.sortProductsByAvailability?.isActive()) {
      await window.sortProductsByAvailability.loadNextPage(this);
      return;
    }

    this.setLoading(true);

    try {
      const response = await fetch(this.dataset.nextUrl);
      if (!response.ok) throw new Error(response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

      const sourceEl = doc.getElementById('product-grid');
      const sourceGrid = sourceEl.tagName === 'UL' ? sourceEl : sourceEl.querySelector('ul');
      const targetGrid = this.getTargetGrid();

      const newItems = [];
      sourceGrid.querySelectorAll(':scope > li').forEach((item) => {
        targetGrid.appendChild(item);
        newItems.push(item);
      });

      this.initAnimations(newItems);
      this.updateCounter(newItems.length);

      const nextBtn = doc.querySelector('load-more-button');
      if (nextBtn?.dataset.nextUrl) {
        this.dataset.nextUrl = nextBtn.dataset.nextUrl;
        this.setLoading(false);
      } else {
        this.remove();
      }
    } catch {
      this.setLoading(false);
    }
  }

  initAnimations(items) {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.remove('scroll-trigger--offscreen');
            obs.unobserve(entry.target);
          } else {
            entry.target.classList.add('scroll-trigger--offscreen');
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    items.forEach((item) => {
      if (item.classList.contains('scroll-trigger')) observer.observe(item);
    });
  }

  updateCounter(addedCount) {
    const counter = document.querySelector('.load-more__counter');
    if (!counter) return;

    const total = parseInt(counter.dataset.total, 10);
    const viewed = Math.min(parseInt(counter.dataset.viewed, 10) + addedCount, total);
    counter.dataset.viewed = viewed;

    counter.textContent = counter.dataset.template
      .replace('__FROM__', 1)
      .replace('__TO__', viewed)
      .replace('__TOTAL__', total);
  }

  setLoading(loading) {
    this.button.disabled = loading;
    this.button.hidden = loading;
    this.spinner.hidden = !loading;
  }
}

customElements.define('load-more-button', LoadMoreButton);
